(function () {
    'use strict';

    angular
        .module('app.campaign')
        .controller('RenameTrackpointModalController', RenameTrackpointModal);

    RenameTrackpointModal.$inject = ['selectedTrackpoint'];
    function RenameTrackpointModal(selectedTrackpoint) {
        var vm = this;

        vm.newName = angular.copy(selectedTrackpoint.name);

        vm.selectedTrackpoint = selectedTrackpoint;

        vm.renameTrackpoint = function () {
            selectedTrackpoint.name = vm.newName;
            Notification.onTrackpointRename(vm.newName);
        }
    }
})();